module.exports = __webpack_public_path__ + "static/arrow_grid-e75457b40214319221fcc36a542fae4c.png";